import { render, staticRenderFns } from "./delete-exam-modal.vue?vue&type=template&id=05991891"
import script from "./delete-exam-modal.vue?vue&type=script&lang=ts"
export * from "./delete-exam-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports